import EditFinancialProductTemplate from '../templates/enquiry/editFinancialProductTemplate.html';

import { find as _find } from 'lodash';

export default class AddEditFinancialProduct {
  constructor($uibModal, $rootScope, authService, financialProductManagementService) {
    "ngInject";

    this.$scope = $rootScope.$new();
    this.$uibModal = $uibModal;
    this.authService = authService;
    this.financialProductManagementService = financialProductManagementService;

    this.$scope.save = this.save;
    this.$scope.add = this.add;
    this.$scope.edit = this.edit;
    this.$scope.closeModal = this.closeModal;
    this.$scope.validateForm = this.validateForm;

    this.$scope.authService = authService;
    this.$scope.financialProductManagementService = financialProductManagementService;
  }

  showAdd(financialProductLookups, callback, fromEnquiry) {
    this.$scope.financialProductLookups = financialProductLookups;
    this.$scope.callback = callback;
    this.$scope.errMsg = "";
    this.$scope.tempExtra = {
    };

    if (fromEnquiry) {
      this.$scope.add = this.addEnquiryOnly;
    }
    else {
      this.$scope.add = this.add;
    }    

    this.$scope.tempExtra = {
      reportable: false
    };    

    this.$scope.modalInstance = this.$uibModal.open({
        template: EditFinancialProductTemplate,
        scope: this.$scope
    });
  }

  showEdit(financialProductLookups, extra) {
    this.$scope.financialProductLookups = financialProductLookups;
    this.$scope.callback = null;
    this.$scope.errMsg = "";
    this.$scope.tempExtra = extra;

    this.$scope.modalInstance = this.$uibModal.open({
        template: EditFinancialProductTemplate,
        scope: this.$scope
    });
  }

  closeModal() {
    const scope = this;

    if (scope.modalInstance) {
      scope.modalInstance.close();
    }
  }

  save() {
    const scope = this;

    if (!scope.validateForm(scope.tempExtra.financialProductId)) {
      return;
    }

    if (!scope.tempExtra.financialProductId) {
      scope.add();
    }
    else {
      scope.edit();
    }
  }

  add() {
    const scope = this;

    scope.financialProductManagementService.addFinancialProduct(scope.authService.authData.currentLocation.key, scope.tempExtra.name, scope.tempExtra.reportable, scope.tempExtra.defaultPrice)
      .then((response) => {
        if (scope.callback) {
          scope.callback({
            financialProductId: response.data,
            name: scope.tempExtra.name,
            defaultPrice: scope.tempExtra.defaultPrice,
            reportable: scope.tempExtra.reportable
          });
        }
      })
      .finally(() => {
        scope.closeModal();
      });
  }

  addEnquiryOnly() {
    const scope = this;

    if (scope.callback) {
      scope.callback({
        name: scope.tempExtra.name,
        defaultPrice: scope.tempExtra.defaultPrice,
        reportable: scope.tempExtra.reportable
      });
    }    

    scope.closeModal();
  }  

  edit() {
    const scope = this;

    scope.financialProductManagementService.editFinancialProduct(scope.authService.authData.currentLocation.key, scope.tempExtra.financialProductId, scope.tempExtra.name, scope.tempExtra.reportable, scope.tempExtra.defaultPrice)
      .then((response) => {
        if (scope.callback) {
          scope.callback({
            id: response.data,
            name: scope.tempExtra.name,
            defaultPrice: scope.tempExtra.defaultPrice,
            reportable: scope.tempExtra.reportable
          });
        }
      })
      .finally(() => {
        scope.closeModal();
      });
  }

  validateForm(financialProductId) {
    const scope = this;

    if (!scope.tempExtra.name || scope.tempExtra.name < 3 || scope.tempExtra.name > 40) {
      scope.errMsg = 'Name is required field and must be between 3 and 40 characters';
      return false;
    }
    else if (_find(scope.financialProductLookups, e =>  {
      let removeEdit = false;
      if (financialProductId) {
        removeEdit = (e.financialProductId !== financialProductId);
      }

      return e.name.toLowerCase() === scope.tempExtra.name.toLowerCase() && removeEdit;
    })) {
      scope.errMsg = `${scope.tempExtra.name} is already added to the list`;
      return;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/addEditFinancialProductService.js